var _rect, _g, _rect2, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGoldenSlot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 121,
    viewBox: "0 0 56 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 121,
    fill: "#F5F5F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3916_412046)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -373,
    width: 429,
    height: 222,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.125 120.5C7.625 120.5 5.4375 119.562 3.5625 117.687C1.6875 115.812 0.75 113.625 0.75 111.125V14.25C0.75 11.75 1.6875 9.5625 3.5625 7.6875C5.4375 5.8125 7.625 4.875 10.125 4.875H20.2812V-4.5H30.4375V4.875H83.5625V-4.5H93.7188V4.875H103.875C106.375 4.875 108.562 5.8125 110.437 7.6875C112.312 9.5625 113.25 11.75 113.25 14.25V111.125C113.25 113.625 112.312 115.812 110.437 117.687C108.562 119.562 106.375 120.5 103.875 120.5H10.125ZM10.125 111.125H103.875V43.9375H10.125V111.125ZM10.125 34.5625H103.875V14.25H10.125V34.5625ZM25.75 67.375V58H88.25V67.375H25.75ZM25.75 95.5V86.125H69.3438V95.5H25.75Z",
    fill: "#F39B17"
  })))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -372,
    y: 1,
    width: 427,
    height: 220,
    rx: 7,
    stroke: "#F39B17",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3916_412046"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -373,
    width: 429,
    height: 222,
    rx: 8,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldenSlot);
export default "data:image/svg+xml,%3csvg width='56' height='121' viewBox='0 0 56 121' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3crect width='56' height='121' fill='%23F5F5F5'/%3e %3cg clip-path='url(%23clip0_3916_412046)'%3e %3crect x='-373' width='429' height='222' rx='8' fill='white'/%3e %3cg opacity='0.1'%3e %3cpath d='M10.125 120.5C7.625 120.5 5.4375 119.562 3.5625 117.687C1.6875 115.812 0.75 113.625 0.75 111.125V14.25C0.75 11.75 1.6875 9.5625 3.5625 7.6875C5.4375 5.8125 7.625 4.875 10.125 4.875H20.2812V-4.5H30.4375V4.875H83.5625V-4.5H93.7188V4.875H103.875C106.375 4.875 108.562 5.8125 110.437 7.6875C112.312 9.5625 113.25 11.75 113.25 14.25V111.125C113.25 113.625 112.312 115.812 110.437 117.687C108.562 119.562 106.375 120.5 103.875 120.5H10.125ZM10.125 111.125H103.875V43.9375H10.125V111.125ZM10.125 34.5625H103.875V14.25H10.125V34.5625ZM25.75 67.375V58H88.25V67.375H25.75ZM25.75 95.5V86.125H69.3438V95.5H25.75Z' fill='%23F39B17'/%3e %3c/g%3e %3c/g%3e %3crect x='-372' y='1' width='427' height='220' rx='7' stroke='%23F39B17' stroke-width='2'/%3e %3cdefs%3e %3cclipPath id='clip0_3916_412046'%3e %3crect x='-373' width='429' height='222' rx='8' fill='white'/%3e %3c/clipPath%3e %3c/defs%3e %3c/svg%3e";
export { ForwardRef as ReactComponent };